import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//Include Both Helper File with needed methods
import {
	getCropTypeList as getCropTypeListApi,
	getCropType as getCropTypeApi,
	addNewCropType as addNewCropTypeApi,
	updateCropType as updateCropTypeApi,
	deleteCropType as deleteCropTypeApi,
} from '../../helpers/establishment/backend_helper';

export const getCropTypeList = createAsyncThunk('cropType/getCropTypeList', async () => {
	try {
		const response = getCropTypeListApi();
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const getCropType = createAsyncThunk('cropType/getCropType', async cropType_id => {
	try {
		const response = getCropTypeApi(cropType_id);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const addNewCropType = createAsyncThunk('cropType/addNewCropType', async cropType => {
	try {
		const response = addNewCropTypeApi(cropType);
		toast.success('Artefacto Naval agregado exitosamente.', { autoClose: 3000 });
		return response;
	} catch (error) {
		toast.error('Error al agregar cropType.', { autoClose: 3000 });
		throw new Error(error);
	}
});

export const updateCropType = createAsyncThunk('cropType/updateCropType', async (cropType) => {
		try {
			const response = updateCropTypeApi(cropType);
			toast.success('Artefacto Naval actualizado exitosamente', { autoClose: 3000 });
			return response;
		} catch (error) {
			toast.error('Error al actualizar cropType.', { autoClose: 3000 });
			throw new Error(error);
		}
	}
);

export const deleteCropType = createAsyncThunk('cropType/deleteCropType', async cropType => {
	try {
		const response = await deleteCropTypeApi(cropType);
		toast.success('Artefacto Naval eliminado exitosamente.', { autoClose: 3000 });
		return { cropType, ...response };
	} catch (error) {
		toast.error('Error al eliminar cropType.', { autoClose: 3000 });
		throw new Error(error);
	}
});


